// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__L32Xo","title-annotation":"Title_title-annotation__3ITGu"};